import * as React from "react";
import { paymentData } from "../Header/menu/data/data";
import styled from "styled-components";
import { IMAGE_SRC } from "../../common/constants";
import borderqr from "../../assets/images/borderqr.svg";
import ReactDOM from "react-dom";
import qrCode from "../../assets/images/qrcode.webp";
import { IDropdownPop } from "../Header/menu/Dropdown";

export interface IPaymentProps {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<IDropdownPop>>;
}

export default function Payment({ show, setShow }: IPaymentProps) {
  const [activeId, setActiveId] = React.useState<number>(1);
  const handleChangeTab = (id: number) => {
    setActiveId(id);
  };
  if (typeof document === "undefined")
    return <div className="modal-payment"></div>;
  return ReactDOM.createPortal(
    <StyledPayment
      className={`modal z-[99] fixed inset-0 flex  ${
        show ? "" : "close-modal"
      } `}
    >
      <div className="m-auto z-50 p-3 modal-signup bg-black  border border-bordermood w-[400px] h-[500px] rounded-lg">
        <div className="flex justify-center items-center">
          <div className="flex  payment-list rounded-[50px] p-3 text-white items-center ">
            {paymentData.map((p, index) => {
              return (
                <button
                  key={p.id}
                  onClick={() => handleChangeTab(p.id)}
                  className={` text-xs py-[7px] w-[100px] flex-shrink-0 btn-payment flex justify-center items-center  text-white rounded-[18px] cursor-pointer ${
                    activeId === p.id ? "active" : ""
                  }`}
                >
                  {p.title}
                </button>
              );
            })}
          </div>
        </div>
        <div className="flex mt-7 text-primary font-medium items-center">
          {activeId === 1 && (
            <span className="text-white text-lg">30k/Month</span>
          )}
          {activeId === 2 && (
            <span className="text-white text-lg">60k/Lifetime</span>
          )}
          {activeId === 3 && (
            <span className="text-white text-lg">250k/Year</span>
          )}
        </div>
        <div className="flex justify-center mt-10">
          <div className="bg-momo rounded-lg p-7">
            <div className="w-[200px] p-3 h-[200px]  relative bg-white rounded-lg">
              {/* <div className="qr-scan">
                  <img src={IMAGE_SRC.scan} alt="" />
                </div> */}
              <div className="absolute p-[6px] inset-0 opacity-90 pointer-events-none w-full h-full z-50">
                <img src={borderqr} alt="" />
              </div>
              <img src={IMAGE_SRC.momo} alt="" />
              <div className="absolute w-10 h-10 rounded-full overflow-hidden p-1  center">
                <img src={IMAGE_SRC.logomomo} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        onClick={() =>
          setShow((prev) => ({
            ...prev,
            showPayment: false,
          }))
        }
        className="absolute inset-0 z-20 bg-black opacity-60 overlay "
      ></div>
    </StyledPayment>,
    document.querySelector("body") as HTMLElement
  );
}
const StyledPayment = styled.div`
  &.close-modal {
    display: none;
  }
  .bg-momo {
    background: url(${qrCode}) 100px 100px no-repeat,
      linear-gradient(0deg, #c1177c, #e11b90);
  }
  .btn-payment.active {
    background-color: hsla(0, 0%, 100%, 0.05);
    color: #f3a952;
  }
  .payment-list {
    background-color: rgba(255, 255, 255, 0.1);
  }
  @keyframes QRCodeScan {
    0% {
      -webkit-transform: translate3d(0, -110%, 0);
      -moz-transform: translate3d(0, -110%, 0);
      transform: translate3d(0, -110%, 0);
    }
    90% {
      -webkit-transform: translate3d(0, 30%, 0);
      -moz-transform: translate3d(0, 30%, 0);
      transform: translate3d(0, 30%, 0);
    }
    100% {
      -webkit-transform: translate3d(0, 30%, 0);
      -moz-transform: translate3d(0, 30%, 0);
      transform: translate3d(0, 30%, 0);
    }
  }
  .qr-scan {
    z-index: 100;
    position: absolute;
    opacity: 0.6;
    width: 98%;
    height: 98%;
    top: 1%;
    left: 1%;
    z-index: 6;
    -webkit-transform: translate3d(0, -110%, 0);
    -moz-transform: translate3d(0, -110%, 0);
    transform: translate3d(0, -110%, 0);
    -webkit-animation: QRCodeScan 3s infinite
      cubic-bezier(0.45, 0.03, 0.81, 0.63);
    -moz-animation: QRCodeScan 3s infinite cubic-bezier(0.45, 0.03, 0.81, 0.63);
    -o-animation: QRCodeScan 3s infinite cubic-bezier(0.45, 0.03, 0.81, 0.63);
    animation: QRCodeScan 3s infinite cubic-bezier(0.45, 0.03, 0.81, 0.63);
    -webkit-backface-visibility: hidden;
    -moz-backface-visibility: hidden;
    backface-visibility: hidden;
  }
`;
